<template>
  <div class="auth-nav header-submenu-item">
    <template v-if="user">
      <div class="auth-nav-user flex gap-4">
        <span class="auth-nav-user-name header-submenu-text">Hi, {{ user.name }}!</span>
        <a href="/logout" @click.prevent="authStore.logout" class="header-submenu-link">Logout</a>
      </div>
    </template>
  </div>
</template>
<script setup lang="ts">
  const authStore = useAuthStore();
  const user =  computed(() => {
    return authStore.getUser;
  });
</script>
